// extracted by mini-css-extract-plugin
module.exports = {"botao":"BotaoOpcao_botao__1xx52","icone":"BotaoOpcao_icone__1N3IV"};